import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-check-text-icon',
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_20439_2987)">
        <path
          d="M9.00016 16.1698L4.83016 11.9998L3.41016 13.4098L9.00016 18.9998L21.0002 6.99984L19.5902 5.58984L9.00016 16.1698Z"
          [attr.fill]="'currentColor'"
        />
      </g>
      <defs>
        <clipPath id="clip0_20439_2987">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckTextIconComponent {}
